import { DomainError } from "@fideus/domain-error";

export class InvalidStateCodeError extends DomainError {
  readonly code = "INVALID_STATE_CODE";
  public readonly state: string;

  constructor(state: string) {
    super("validation.taxId.invalidState", { state }, 400);
    this.state = state;
  }
}
